import _defineProperty from "/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var genStepsProgressStyle = function genStepsProgressStyle(token) {
  var _$concat5;

  var antCls = token.antCls,
      componentCls = token.componentCls;
  return _defineProperty({}, "&".concat(componentCls, "-with-progress"), (_$concat5 = {}, _defineProperty(_$concat5, "".concat(componentCls, "-item"), _defineProperty({
    paddingTop: token.paddingXXS
  }, "&-process ".concat(componentCls, "-item-container ").concat(componentCls, "-item-icon ").concat(componentCls, "-icon"), {
    color: token.processIconColor
  })), _defineProperty(_$concat5, "&".concat(componentCls, "-vertical > ").concat(componentCls, "-item "), _defineProperty({
    paddingInlineStart: token.paddingXXS
  }, "> ".concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    top: token.marginXXS,
    insetInlineStart: token.stepsIconSize / 2 - token.lineWidth + token.paddingXXS
  })), _defineProperty(_$concat5, "&, &".concat(componentCls, "-small"), _defineProperty({}, "&".concat(componentCls, "-horizontal ").concat(componentCls, "-item:first-child"), {
    paddingBottom: token.paddingXXS,
    paddingInlineStart: token.paddingXXS
  })), _defineProperty(_$concat5, "&".concat(componentCls, "-small").concat(componentCls, "-vertical > ").concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    insetInlineStart: token.stepsSmallIconSize / 2 - token.lineWidth + token.paddingXXS
  }), _defineProperty(_$concat5, "&".concat(componentCls, "-label-vertical"), _defineProperty({}, "".concat(componentCls, "-item ").concat(componentCls, "-item-tail"), {
    top: token.margin - 2 * token.lineWidth
  })), _defineProperty(_$concat5, "".concat(componentCls, "-item-icon"), _defineProperty({
    position: 'relative'
  }, "".concat(antCls, "-progress"), {
    position: 'absolute',
    insetBlockStart: (token.stepsIconSize - token.stepsProgressSize - token.lineWidth * 2) / 2,
    insetInlineStart: (token.stepsIconSize - token.stepsProgressSize - token.lineWidth * 2) / 2
  })), _$concat5));
};

export default genStepsProgressStyle;